import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const steps = [{
  n: '1',
  time: 'Day 1',
  title: 'Free Quote',
  body: 'Mike visits your home, measures up, recommends honestly. No fee. No follow up sales calls unless you ask.'
}, {
  n: '2',
  time: 'Within 48 hours',
  title: 'Fixed Proposal',
  body: 'Full quote in your inbox. Brand, model, install scope, electrical, removal of old gear, all included. Fixed price in writing.'
}, {
  n: '3',
  time: '1 to 3 days',
  title: 'Install Day',
  body: 'Our own team arrives on time. Drop sheets down. Mess cleaned up. We walk you through the controls before we leave.'
}, {
  n: '4',
  time: 'For life',
  title: 'Lifetime Support',
  body: 'Anything goes wrong with our workmanship, you call us. We come back free. We also handle manufacturer warranty claims for you.'
}];
export function Process() {
  return <section className="bg-white py-20 md:py-28 scroll-mt-24" data-id="element-512">
      <div className="max-w-6xl mx-auto px-6" data-id="element-513">
        <div className="max-w-3xl mb-14" data-id="element-514">
          <div className="kicker mb-3" data-id="element-515">How we work</div>
          <h2 className="text-3xl md:text-5xl font-bold text-ink-900 tracking-tight leading-tight" data-id="element-516">
            What happens after you click the button.
          </h2>
          <p className="mt-4 text-lg text-stone-600" data-id="element-517">
            Same day quote callback. Install dates discussed at the on site
            quote.
          </p>
        </div>

        <div className="relative" data-id="element-518">
          <div className="hidden lg:block absolute top-7 left-[7%] right-[7%] h-px bg-stone-200" aria-hidden="true" data-id="element-519"></div>

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 lg:gap-6" data-id="element-520">
            {steps.map((step, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="relative" data-id="element-521">
                <div className="relative z-10 w-14 h-14 rounded-full bg-brand text-white flex items-center justify-center text-xl font-extrabold mb-6 border-4 border-white tabular-nums shadow-md" data-id="element-522">
                  {step.n}
                </div>

                <div className="inline-flex items-center gap-1.5 px-2.5 h-6 rounded-full bg-brand-soft text-brand text-xs font-bold uppercase tracking-wider mb-3" data-id="element-523">
                  {step.time}
                </div>

                <h3 className="text-xl font-extrabold text-ink-900 tracking-tight leading-tight mb-3" data-id="element-524">
                  {step.title}
                </h3>
                <p className="text-sm text-stone-600 leading-relaxed" data-id="element-525">
                  {step.body}
                </p>
              </motion.div>)}
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-526">
          <a href="#quote-form" className="inline-flex items-center gap-2 text-brand font-semibold hover:underline" data-id="element-527">
            Get my free quote <ArrowRight size={14} data-id="element-528" />
          </a>
        </div>
      </div>
    </section>;
}